// Constants
import { RESET_STATE } from '../auth/constants';
import {
    SET_HOVERED_TABLE_CELL,
    RESET_HOVERED_TABLE_CELL,
    ADD_ACTIVE_TABLE_ROW,
    REMOVE_ACTIVE_TABLE_ROW,
    SET_SELECTED_TABLE_COLUMN_NAME,
    SET_SELECTED_TABLE_CELL,
    ADD_SELECTED_TABLE_ROW,
    REMOVE_SELECTED_TABLE_ROW,
    RESET_SELECTED_TABLE_CELLS
} from './constants';

const initialState = {
    // For storing hover state
    hoveredColumnId: null,
    hoveredRowId: null,

    // For storing selected state when a row is selected using a checkbox
    activeRowIds: [],

    // For storing the state when a row or cell is clicked
    selectedColumnId: null,
    selectedRowIds: []
};

export default function(state = initialState, action) {
    switch (action.type) {
        case SET_HOVERED_TABLE_CELL: {
            const { rowId, columnName } = action.payload;
            return {
                ...state,
                hoveredColumnId: columnName,
                hoveredRowId: rowId
            };
        }
        case RESET_HOVERED_TABLE_CELL:
            return {
                ...state,
                hoveredColumnId: null,
                hoveredRowId: null
            };
        case ADD_ACTIVE_TABLE_ROW: {
            const { rowId } = action.payload;
            return {
                ...state,
                activeRowIds: state.activeRowIds.concat(rowId),
                selectedColumnId: null,
                selectedRowIds: []
            };
        }
        case REMOVE_ACTIVE_TABLE_ROW: {
            const { rowId } = action.payload;
            return {
                ...state,
                activeRowIds: state.activeRowIds.filter(
                    value => !rowId.toString().includes(value)
                )
            };
        }
        case SET_SELECTED_TABLE_COLUMN_NAME: {
            const { columnName } = action.payload;
            return {
                ...state,
                activeRowIds: [],
                selectedColumnId: columnName
            };
        }
        case SET_SELECTED_TABLE_CELL: {
            const { rowId, columnName } = action.payload;
            return {
                ...state,
                activeRowIds: [],
                selectedColumnId: columnName,
                selectedRowIds: [rowId]
            };
        }
        case ADD_SELECTED_TABLE_ROW: {
            const { rowId, columnName } = action.payload;
            if (columnName) {
                return {
                    ...state,
                    activeRowIds: [],
                    selectedColumnId: columnName,
                    selectedRowIds:
                        columnName === state.selectedColumnId
                            ? state.selectedRowIds.concat(rowId)
                            : [rowId]
                };
            }
            return {
                ...state,
                activeRowIds: [],
                selectedRowIds: state.selectedRowIds.concat(rowId)
            };
        }
        case REMOVE_SELECTED_TABLE_ROW: {
            const { rowId } = action.payload;
            return {
                ...state,
                selectedRowIds: state.selectedRowIds.filter(
                    value => !rowId.toString().includes(value)
                )
            };
        }
        case RESET_SELECTED_TABLE_CELLS:
        case RESET_STATE:
            return initialState;
        default:
            return state;
    }
}
